---
title: Voice conversations
summary: Talk to an expert hands-free or push-to-talk, hear replies aloud, and interrupt any time.
visibility: authenticated
feature: voice
audience: end-user
section: Using an expert
order: 112
last_verified: 2026-10-25
owner: docs
---

# Voice conversations

When a persona supports voice, you can speak to it and hear it reply.

## Hear replies aloud

The voice bar above the conversation has a **Voice On / Off** toggle for spoken replies.
While the expert is speaking you can click it to stop playback. You can also pick which voice
you hear from the voice selector — the persona's own voice is marked **Persona default**, and
choosing another shows an **Override** badge for your session.

## Two ways to talk

Use the microphone button next to the message box:

- **Push-to-talk** — **hold** the mic button while you speak and release when you're done.
  (A quick click also works as a start/stop toggle: click again when you're done.) Pausing
  doesn't end your turn; it ends when you release or click again, or after a minute without
  words. You can start talking as soon as you press: nothing you say while the mic connects
  is lost. Good for noisy rooms where you don't want the mic always listening.
- **Open mic** (hands-free) — turn it on and just talk; the app detects when you start and
  stop speaking on its own. On cloud deployments, a sound with no words, like a cough or a
  door, is let go after a few seconds (4 by default; change it under Settings, Voice, Voice
  Conversation). Good for a natural back-and-forth.

While you're talking, a small overlay shows what it's hearing.

## Interrupt any time

If the expert is speaking and you start talking, it stops and listens to you — so you can
jump in without waiting for it to finish.

## Good to know

- Voice needs speech services to be set up for the deployment. If something isn't configured,
  the voice bar tells you what's missing.
- Speech recognition works best in Chrome or Edge.

## Next

- [Talk to a video avatar](/help/enduser/talk-to-an-avatar) — a face as well as a voice.
